import type { InsightType } from './insightType';

export enum BenchmarkCategory {
  Traffic = 'traffic',
  Engagement = 'engagement',
  Growth = 'growth',
}

export enum BenchmarkMode {
  TopCountry = 0,
  SelectedCountry = 1,
  TopOpportunities = 2,
  TopAchievements = 3,
}

export type Benchmark = {
  code: string;
  units?: string;
  metric: string;
  visitsMetric?: string;
  category: BenchmarkCategory;
  growthMetric: boolean;
  greaterIsBetter: boolean;
  weightedAverage: boolean;
  topic: string;
  mode: BenchmarkMode;
};

export type Prospect = {
  domain: string;
  favicon: string;
  value: number;
  visits: number;
};

export type BenchmarkCompetitor = Prospect & {
  isOutperforming: boolean;
  isUserDefined: boolean;
};

export type AggregatedDetails = {
  points: number;
  avgValue: number;
  domains: string[];
  opportunity: number;
};

export type Opportunity = {
  id: string;
  insightType: InsightType.Opportunity;
  country: number;
  dataDate: string;
  prospect: Prospect;
  lastSendEmailBenchmarkDate?: string;
  benchmark: Benchmark;
  competitors?: BenchmarkCompetitor[];
  outperformingCompetitors?: AggregatedDetails;
  underperformingCompetitors?: AggregatedDetails;
};

export type Competitor = { domain: string; isSelected?: boolean };

export type AdNetwork = {
  id: string;
  isNew: boolean;
  change?: number;
  name: string;
  share: number;
  visits: number;
};
